import { useEffect, useState, useContext } from "react";
import { loadArticles } from "../data/loadArticles";
import BlogCard from "./BlogCard";
import { NameContext } from "../context/NameContext";
import UnderlineSketch from "./UnderlineSketch";

export default function BlogListBlog({ currentSlug, max = 3 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { name } = useContext(NameContext);


  useEffect(() => {
    loadArticles().then((data) => {
      // Filtere den aktuellen Post raus
      const filtered = data.filter(post => post.slug !== currentSlug);
      setPosts(filtered);
      setLoading(false);
    });
  }, [currentSlug]);

  if (loading) return <div className="py-10 text-center font-mono text-xs text-[#EFEBDC]0">Lade weitere Beiträge…</div>;
  if (!posts.length) return null;

  return (
    <div className="mt-16 p-4 max-w-4xl mx-auto">
        <div className="py-10">
    
        </div>
      <h3 className="font-mono text-xs text-brand mb-6 text-center sm:text-left">Weiteres Wissen für Dich {name}</h3>
      <div className="grid gap-6 sm:grid-cols-2">
        {posts.slice(0, max).map(post => (
          <BlogCard post={post} key={post.slug} />
        ))}
      </div>
      <div className="py-10">
      <UnderlineSketch 
      color="zenBrand"
      
      >
 
        </UnderlineSketch></div>
    </div>
  );
}
